/**
 * XS-Common 签名器
 * 移植自 xhshow-go/xhshow/xs_common.go
 */

import { PUBLIC_USER_AGENT } from './config.js';
import { encodeCustomBase64 } from './utils/index.js';
import { crc32JsInt } from './crypto/index.js';
import { FingerprintGenerator } from './fingerprint/generator.js';
import type { CookieDict } from './types/index.js';

export class XsCommonSigner {
  private fpGenerator: FingerprintGenerator;

  constructor() {
    this.fpGenerator = new FingerprintGenerator();
  }

  /**
   * 生成 x-s-common 签名
   */
  sign(cookieDict: CookieDict): string {
    // 1. 生成指纹
    const fp = this.fpGenerator.generate(cookieDict, PUBLIC_USER_AGENT);

    // 2. 生成 b1
    const b1 = this.fpGenerator.generateB1(fp);

    // 3. 计算 b1 的 CRC32
    const x9 = crc32JsInt(Buffer.from(b1, 'utf8'));

    // 4. 构建签名 Map
    if (!cookieDict.a1) {
      throw new Error("missing 'a1' in cookieDict");
    }
    const a1Str = String(cookieDict.a1);

    const sig = {
      s0: 5,
      s1: '',
      x0: '1',
      x1: '4.2.6',
      x2: 'Windows',
      x3: 'xhs-pc-web',
      x4: '4.86.0',
      x5: a1Str,
      x6: '',
      x7: '',
      x8: b1,
      x9: x9,
      x10: 0,
      x11: 'normal',
    };

    // 5. 编码
    const jsonBytes = Buffer.from(JSON.stringify(sig), 'utf8');

    return encodeCustomBase64(jsonBytes);
  }
}
